import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'LoanInstalment';
const ENDPOINT = `/loan-instalments/`;

@Injectable({
    providedIn: 'root'
})
export class LoanInstalmentService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
